import {
  Box,
  Skeleton,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material';

interface LoadingTypographyProps extends TypographyProps {
  isLoading: boolean;
  children?: React.ReactNode;
  skeletonWidth?: string | number;
  skeletonHeight?: string | number;
  showTooltip?: boolean;
}

export const LoadingTypography = ({
  isLoading,
  children,
  skeletonWidth = '100%',
  skeletonHeight = '100%',
  showTooltip,
  ...typographyProps
}: LoadingTypographyProps) => {
  const skeletonTypography = (
    <Typography {...typographyProps} component={Box}>
      {isLoading ? (
        <Skeleton
          width={skeletonWidth}
          height={skeletonHeight}
          animation="wave"
          sx={{ display: 'inherit' }}
        />
      ) : (
        children
      )}
    </Typography>
  );

  if (showTooltip) {
    return <Tooltip title={children as string}>{skeletonTypography}</Tooltip>;
  }

  return skeletonTypography;
};
